<template>
  <div id="footer">
    <div class="container mt-5 mb-3">
      <div class="row">
        <div class="col-6">
          <a target="_blank" href="https://www.facebook.com/bloomsnature4"><i class="fa fa-facebook social-icon" aria-hidden="true"></i></a>
          <a target="_blank" href="https://www.instagram.com/blooms.nature_/"><i class="fa fa-instagram social-icon" aria-hidden="true"></i></a>
        </div>
        <div class="col-6 policy-col" style="text-align: right">
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="https://shop.bloomsnature.com/about-us/">About Us</a></li>
            <li><a href="https://shop.bloomsnature.com/">Shop</a></li>
            <li><a href="https://shop.bloomsnature.com/contact-us/">Contact Us</a></li>
          </ul>
        </div>
      </div>
    </div>

    <section class="copyright-footer p-3">
      <div class="container">
        <div class="row">
          <div class="col-lg-8 col-md-7">
            © {{ new Date().getFullYear() }} Blooms Nature. All Rights Reserved.
          </div>
          <div class="col-lg-4 col-md-5 phone-col">
            <div class="row">
              <div class="col-6">
                <i class="fa fa-phone" aria-hidden="true"></i> +6012 885 6959
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
name: "MyFooter"
}
</script>

<style scoped>

</style>
